"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _borderRadius = require("../../tokens/borderRadius");

var _colors = require("../../tokens/colors");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var common = {
  style: {
    boxShadow: '0 3px 16px 0 rgba(0, 0, 0, 0.24)',
    borderRadius: _borderRadius.BorderRadius.labelRadius,
    minWidth: '28px',
    minHeight: '28px',
    padding: '8px 12px',
    display: 'block',
    transition: 'opacity .3s ease-in-out, visibility .3s ease-in-out'
  },
  arrowStyle: {
    borderColor: false,
    transition: false
  }
};
var defaultTheme = {
  light: {
    style: _objectSpread(_objectSpread({}, common.style), {}, {
      background: _colors.COLORS.BgMain,
      color: _colors.COLORS.TextPrimary
    }),
    arrowStyle: _objectSpread(_objectSpread({}, common.arrowStyle), {}, {
      color: _colors.COLORS.BgMain
    })
  },
  dark: {
    style: _objectSpread(_objectSpread({}, common.style), {}, {
      background: _colors.COLORS.ButtonPrimary,
      color: _colors.COLORS.TextWhite
    }),
    arrowStyle: _objectSpread(_objectSpread({}, common.arrowStyle), {}, {
      color: _colors.COLORS.ButtonPrimary
    })
  }
};
var _default = defaultTheme;
exports["default"] = _default;